import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { Checkbox, ICheckboxProps } from '../../../../ui';

export const SaveVehicle = (props: Partial<ICheckboxProps>) => {
	const { t } = useTranslation();
	const { register } = useFormContext();

	return (
		<Checkbox
			label={t('parking_personal_details_save_vehicle')}
			{...props}
			{...register('saveVehicle')}
		/>
	);
};
